// const config = {PATH: `http://localhost:8000`,
const config = { PATH: `https://dev.momentumaudit.app`,
// const config = { PATH: `https://momentumaudit.app`,
    readonly: false,
  toolbarSticky: false,
  toolbarAdaptive: false,
  // statusbar: false,
  
// # ----------------ENCRYPT DECRYPT SECRET-----------------------------
SECRET_KEY:'Misafeauditapp2026@secret',
  
  buttons: [
    'bold',
    'italic',
    'underline',
    {
      name: 'my-ul',
      icon: 'ul',
      exec: (editor) => {
        editor.execCommand('insertUnorderedList');
      },
      tooltip: 'Bullet List',
    },
    {
      name: 'my-ol',
      icon: 'ol',
      exec: (editor) => {
        editor.execCommand('insertOrderedList');
      },
      tooltip: 'Numbered List',
    },
    // 'brush',
    'lineHeight',
    'fontsize',
    'font',
    {
      name: 'insertBreak',
      icon: 'paragraph',
      tooltip: 'Insert Line Break',
      exec: (editor) => {
        editor.s.focus(); // Ensure focus
        editor.selection.insertHTML('<br>'); // Insert line break
      },
    },

  ],
    // Enables font size and font family dropdowns
    controls: {
      font: {
        list: {
          'Arial': 'Arial',
          'Times New Roman': 'Times New Roman',
          'Verdana': 'Verdana',
          'Courier New': 'Courier New',
          'Georgia': 'Georgia',
        },
      },
      fontsize: {
        list: ['8', '10', '12', '14', '16', '18', '24', '36', '48']
      },
    },

  colorPickerDefaultTab: 'text', // Always show text color first
  showBackgroundOnColorPicker: false, // Hides background color tab

  askBeforePasteFromHTML: false,
  askBeforePasteFromWord: false,
  processPasteFromWord: true,
  defaultActionOnPaste: 'insert_clear_html',  // Clears formatting but keeps structure
  pasteHTMLAction: 'insert_clear_html',
  askBeforePasteHTML: false,

  askBeforePasteFromHTML: false,
askBeforePasteFromWord: false,
processPasteFromWord: true,
defaultActionOnPaste: "insert",
pasteHTMLAction: "insert",

  // disablePlugins: ['list', 'pasteDialog', 'paste'],
  disablePlugins: [
  'list',
  'pasteDialog',
  // 'paste',
  
  'addNewLine', 
],


  cleanHTML: {
    // removeStyles: true,
    removeStyles: false, //  allow inline font styles to persist
    removeClasses: true,
  },

  pasteFromClipboard: true,
  
}; // remove this while pushing it to dev or prod

// const config = { PATH: `https://dev.momentumaudit.app` }; // remove this while pushing prod
//  const config = { PATH: `https://momentumaudit.app`,readonly: false,
//   toolbarSticky: false,

//   buttons: [
//     'bold',
//     'italic',
//     'underline',
//     {
//       name: 'my-ul',
//       icon: 'ul',
//       exec: (editor) => {
//         editor.execCommand('insertUnorderedList');
//       },
//       tooltip: 'Bullet List',
//     },
//     {
//       name: 'my-ol',
//       icon: 'ol',
//       exec: (editor) => {
//         editor.execCommand('insertOrderedList');
//       },
//       tooltip: 'Numbered List',
//     },
//     // 'brush',
//     'lineHeight',
//     'fontsize',
//     'font',
//     {
//       name: 'insertBreak',
//       icon: 'paragraph',
//       tooltip: 'Insert Line Break',
//       exec: (editor) => {
//         editor.s.focus(); // Ensure focus
//         editor.selection.insertHTML('<br>'); // Insert line break
//       },
//     },

//   ],
//     // Enables font size and font family dropdowns
//     controls: {
//       font: {
//         list: {
//           'Arial': 'Arial',
//           'Times New Roman': 'Times New Roman',
//           'Verdana': 'Verdana',
//           'Courier New': 'Courier New',
//           'Georgia': 'Georgia',
//         },
//       },
//       fontsize: {
//         list: ['8', '10', '12', '14', '16', '18', '24', '36', '48']
//       },
//     },

//   colorPickerDefaultTab: 'text', // Always show text color first
//   showBackgroundOnColorPicker: false, // Hides background color tab

//   askBeforePasteFromHTML: false,
//   askBeforePasteFromWord: false,
//   processPasteFromWord: true,
//   defaultActionOnPaste: 'insert_clear_html',  // Clears formatting but keeps structure
//   pasteHTMLAction: 'insert_clear_html',

//   disablePlugins: ['list', 'pasteDialog', 'paste'],

//   cleanHTML: {
//     // removeStyles: true,
//     removeStyles: false, 

//     removeClasses: true,
//   },

//   pasteFromClipboard: true,}; // remove this while pushing it to dev


export { config };